<template>
    <v-scale-transition>
        <v-card flat tile color="transparent" max-width="700" v-show="visible" class="pt-5">

            <v-card flat tile color="#edf2f7">

                <v-card-text :class="'panel-' + color">

                    <v-container class="pa-0">

                        <v-row dense>
                            <v-col cols="12" align="left">


                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_text"
                                        @input="translationsChanged"
                                        hint="Project info text">
                                    <b>{{translations.project_info_text}}</b>
                                </text-editor>

                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="8" align="left">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_duration_text"
                                        @input="translationsChanged"
                                        hint="Project duration text">
                                    {{translations.project_info_duration_text}}
                                </text-editor>
                            </v-col>

                            <v-col cols="4" align="right">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_duration"
                                        @input="translationsChanged"
                                        hint="Project duration text">
                                    {{duration}}
                                </text-editor>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="8" align="left">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_reward_text"
                                        @input="translationsChanged"
                                        hint="Project reward text">
                                    {{translations.project_info_reward_text}}
                                </text-editor>
                            </v-col>

                            <v-col cols="4" align="right">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_reward"
                                        @input="translationsChanged"
                                        hint="Project reward">
                                    {{rewardPoints}}
                                </text-editor>
                            </v-col>
                        </v-row>

                        <!-- MOBILE COMPATIBLE -->
                        <v-row dense>
                            <v-col cols="8" align="left">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_mobile_text"
                                        @input="translationsChanged"
                                        hint="Mobile compatible text">
                                    {{translations.project_info_mobile_text}}
                                </text-editor>
                            </v-col>

                            <v-col cols="4" align="right">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_incompatible_text"
                                        @input="translationsChanged"
                                        hint="Incompatible text">
                                    {{mobileCompatible}}
                                </text-editor>
                            </v-col>
                        </v-row>

                        <!-- TABLE COMPATIBLE -->
                        <v-row dense>
                            <v-col cols="8" align="left">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_tablet_text"
                                        @input="translationsChanged"
                                        hint="Tablet compatible text">
                                    {{translations.project_info_tablet_text}}
                                </text-editor>
                            </v-col>

                            <v-col cols="4" align="right">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_compatible_text"
                                        @input="translationsChanged"
                                        hint="Compatible text">
                                    {{tabletCompatible}}
                                </text-editor>
                            </v-col>
                        </v-row>

                        <!-- DESKTOP COMPATIBLE -->
                        <v-row dense>
                            <v-col cols="8" align="left">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_desktop_text"
                                        @input="translationsChanged"
                                        hint="Desktop compatible text">
                                    {{translations.project_info_desktop_text}}
                                </text-editor>
                            </v-col>

                            <v-col cols="4" align="right">
                                <text-editor
                                        :editable="editable"
                                        v-model="translations.project_info_compatible_text"
                                        @input="translationsChanged"
                                        hint="Compatible text">
                                    {{desktopCompatible}}
                                </text-editor>
                            </v-col>
                        </v-row>

                    </v-container>

                    <json v-if="debug" :data="project"></json>
                </v-card-text>

            </v-card>
        </v-card>
    </v-scale-transition>
</template>

<script>

    import TextEditor from "../TextEditor";
    import Json from 'vue-json-pretty';

    export default {

        components: {
            TextEditor,
            Json,
        },
        props: {
            value: {
                type: Object,
                required: true,
            },
            visible: {
                type: Boolean,
                required: false,
                default: true,
            },
            editable: {
                type: Boolean,
                required: false,
                default: true,
            },
            project: {
                type: Object,
                required: true,
                default: () => {
                    return {
                        reward_completed: null,
                        loi: null,
                        mobile_friendly: null,
                        tablet_friendly: null,
                        desktop_friendly: null,
                    }
                }
            },
            color: {
                type: String,
                required: true,
            }
        },

        computed: {
            duration() {
                if (this.translations.project_info_duration) {
                    return this.translations.project_info_duration.replace('[duration]', this.project.loi);
                }
            },
            mobileCompatible() {
                return this.project.mobile_friendly ?
                    this.translations.project_info_compatible_text :
                    this.translations.project_info_incompatible_text;
            },
            tabletCompatible() {
                return this.project.tablet_friendly ?
                    this.translations.project_info_compatible_text :
                    this.translations.project_info_incompatible_text;
            },
            desktopCompatible() {
                return this.project.desktop_friendly ?
                    this.translations.project_info_compatible_text :
                    this.translations.project_info_incompatible_text;
            },
            rewardPoints() {
                if (this.translations.project_info_reward) {
                    return this.translations.project_info_reward.replace('[reward-points]', this.project.reward_completed);
                }
            }
        },

        data() {
            return {
                debug: false,
                translations: {
                    project_info_text: null,
                    project_info_duration_text: null,
                    project_info_duration: null,
                    project_info_reward_text: null,
                    project_info_reward: null,
                    project_info_compatible_text: null,
                    project_info_incompatible_text: null,
                    project_info_mobile_text: null,
                    project_info_tablet_text: null,
                    project_info_desktop_text: null,
                },
            }
        },

        mounted() {
            this.translations = Object.assign({}, this.value);
        },

        watch: {
            value(translations) {
                this.translations = Object.assign({}, translations);
            }
        },

        methods: {
            translationsChanged() {
                this.$emit('input', this.translations);
            }
        }
    }
</script>

<style scoped>

    .panel-blue {
        border-left: 4px solid #3097D1 !important;
    }

    .panel-green {
        border-left: 4px solid #2ab27b !important;
    }

    .panel-red {
        border-left: 4px solid #bf5329 !important;
    }

</style>